import { ReactComponent as BlockQuotes } from "../../app/assets/icons/block-quotes.svg";
import { ReactComponent as HandShakeSVG } from "../../app/assets/icons/hand-shake.svg";
import NoAuthFooter from "../NoAuthFooter/NoAuthFooter";
import "./signout-layout.scss";

interface ForgotPasswordLayoutProps {
  children: React.ReactNode;
  headerText: string;
  subHeaderText?: string;
  maskedEmail?: string;
  isStep2?: boolean;
  isStep3?: boolean;
  isLogoutPage?: boolean;
}

const WhiteLabelTextHeader = () => {
  return (
    <div className="d-flex justify-content-center align-items-center">
      <BlockQuotes />
      <h3 className="logoTextHeader">WHITELABEL</h3>
    </div>
  );
};

const SignoutPageLayout = ({
  children,
  headerText,
  subHeaderText = "",
  maskedEmail,
  isStep2 = false,
  isStep3 = false,
  isLogoutPage = false,
}: ForgotPasswordLayoutProps) => {
  return (
    <div className="container h-100">
      <div className="d-flex justify-content-between mx-auto h-100 flex-column pt-5 pb-2">
        {!isLogoutPage && <WhiteLabelTextHeader />}

        <div
          className={`d-flex flex-column align-items-center ${isStep2 ? "mt-5 mb-5 pt-3 pb-3" : ""}`}
        >
          {isStep3 && <HandShakeSVG />}
          <h2 className="header-text text-center">{headerText}</h2>

          <div className={`form-container ${isStep3 ? "text-center" : ""}`}>
            {isStep2 && maskedEmail && (
              <p className="text-center">
                An email was sent to your inbox at{" "}
                <span className="highlight-text">{maskedEmail}</span> with a
                confirmation code.
              </p>
            )}

            <p className={isStep3 ? "" : "text-center"}>{subHeaderText}</p>
            {children}
          </div>
        </div>
        {!isLogoutPage && <NoAuthFooter extraClasses="py-2" />}
      </div>
    </div>
  );
};

export default SignoutPageLayout;
